<template>
  <div class="form tab-content scroll-fire-fox" id="typification-tab">
    <typification-form
      v-if="!disabled"
      :object-data="objectData"
      @addTypification="addTypification"
    />
    <typification-table
      :entries="entries"
      :disabled="disabled"
      @update-item="updateItem($event.index, $event.item)"
      @delete="deleteItem"
    />
  </div>
</template>

<script>
import TypificationTable from "@/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationTable";
import TypificationForm from "@/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationForm";

export default {
  name: "BuildingTypification",

  components: { TypificationForm, TypificationTable },

  props: {
    objectData: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      entries: []
    };
  },

  computed: {
    originalEntries() {
      if (this.objectData.hasOwnProperty("building_typification")) {
        return this.objectData.building_typification;
      }
      return [];
    }
  },

  mounted() {
    this.updateEntries();
  },

  methods: {
    updateEntries() {
      this.entries = Array.from(this.originalEntries);
    },

    addTypification(newTypification) {
      this.entries = this.entries.concat(newTypification);
    },

    updateItem(index, item) {
      this.entries.splice(index, 1, item);
      this.$emit("updateEntries", this.entries);
    },

    deleteItem(index) {
      this.entries.splice(index, 1);
    }
  },

  watch: {
    originalEntries() {
      this.entries = Array.from(this.originalEntries);
    },

    entries(newSet) {
      if (newSet.length !== this.originalEntries.length) {
        this.$emit("updateEntries", newSet);
      }
    }
  }
};
</script>

<style scoped>
#typification-tab {
  width: 100%;
  max-height: 65vh;
  overflow: auto;
  padding-left: 30px;
  padding-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Typification/BuildingTypification.vue